import { colours, build } from './../helpers';

export const caseMetricsPointColorsToOptions = (pointColors, seriesColors) => {
  const length = pointColors.length;
  const numSeries = seriesColors.length;
  if (length === 0 || numSeries === 0) { return []; }

  const seriesArr = Array(numSeries);
  for (let i = 0; i < numSeries; i++) {
    seriesArr[i] = Array(length);
  }
  for (let k = 0; k < numSeries; k++) {
    seriesArr[k][0] = {
      pointBackgroundColor: seriesColors[k],
      pointRadius: length > 1 ? 0 : 4
    };
  }
  for (let i = 1; i < length; i++) {
    for (let j = 0; j < numSeries; j++) {
      seriesArr[j][i] = {
        pointBackgroundColor: pointColors[i][j],
        pointRadius: pointColors[i][j] !== colours.METRICS_CHARTS.RED &&
        pointColors[i][j] !== colours.METRICS_CHARTS.YELLOW ?
          0 :
          4
      };
    }
  }
  return formatPointOptionArray(seriesArr);
};

export const multiLineDataToFormattedPointOptions = (dataArray, colorsArray) => {
  const pointOptions = multiLineDataToPointOptions(dataArray, colorsArray);
  const formatted = formatPointOptionArray(pointOptions);
  return formatted;
};

export const singleLineDataToFormattedPointOptions = (data, color) => {
  const pointOptions = singleLineDataToPointOptions(data, color);
  const formatted = formatPointOptionArray([pointOptions]);
  return formatted;
};

export const multiLineDataToPointOptions = (dataArray, colorsArray) => {
  const pointOptions = colorsArray.map((color, index) =>
    singleLineDataToPointOptions(dataArray[index], color));
  return pointOptions;
};

export const singleLineDataToPointOptions = (data, defaultColor) => {
  const length = data.length;
  if (length === 0) return [];

  const arrOfPointOptions = data.map((num, index) => {
    const compareIndex = index === 0 ? 0 : index - 1;
    const pointHasDelta = data[index] !== data[compareIndex];

    return makePointOption(
      pointHasDelta ? colours.METRICS_CHARTS.RED : defaultColor,
      pointHasDelta || length === 1 ? 4 : 0
    );
  });

  return arrOfPointOptions;
};

// intended as a footer callback to a LineChartComponent
// in the context of hover over a metric job, this will place the jobId
// into the footer of the tooltip displayed
export const metricsJobIdTooltipFooter = (tooltipItem) => (metrics) => {
  const metric = metrics[tooltipItem[0].index];
  return metric ? `JobId: ${metric.jobId}` : '';
};

export const metricsNotesTooltipFooter = () => {
  return 'Total: Search & Decryption Times';
};

export const releaseMetricsVersionTooltipTitle = (tooltipItem) => (info, metrics) => {
  const metric = metrics[tooltipItem[0].index];
  const isProcess = info.product === build.PRODUCTS.PROCESS;
  return metric ? [
    `Process: ${isProcess ? metric.productVersion : metric.complementVersion}`,
    `Engine: ${isProcess ? metric.complementVersion : metric.productVersion}`
  ] :
    '';
};

const makePointOption = (color, radius) => {
  return {
    pointBackgroundColor: color,
    pointRadius: radius
  };
};

export const formatPointOptionArray = (setArr) => setArr.map(set => {
  return {
    pointBackgroundColor: set.map(p => p && p.pointBackgroundColor),
    pointRadius: set.map(p => p && p.pointRadius)
  };
});



// WEBPACK FOOTER //
// src/helpers/chart.js